import { motion } from "framer-motion";
import { PhoneCall } from "lucide-react";
import { waLink, WHATSAPP_DISPLAY } from "../lib/whatsapp";

const URGENT_MESSAGE =
  "URGENCE — besoin de renfort pour mon événement (serveur / maître d'hôtel). Merci de me répondre au plus vite.";

const lines = [
  { text: "Vous êtes dans la merde :", accent: false },
  { text: "un serveur vous a lâché,", accent: false },
  { text: "la salle n'est pas remise au propre,", accent: true },
  { text: "besoin de renfort ?", accent: false },
];

export const Urgence = () => (
  <section data-testid="urgence-section" className="grain relative overflow-hidden bg-[#0a0a0a] px-6 py-24 lg:px-10 lg:py-32">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/10 blur-[120px]" />
    <div className="relative mx-auto max-w-6xl text-center">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="text-[11px] font-bold uppercase tracking-[0.5em] text-gold"
        data-testid="urgence-label"
      >
        Urgence FK Événement
      </motion.p>
      <h2 className="mt-8 font-display text-4xl leading-[1.08] tracking-tight text-white sm:text-6xl lg:text-7xl" data-testid="urgence-slogan">
        {lines.map((l, i) => (
          <motion.span
            key={l.text}
            initial={{ opacity: 0, scale: 1.3, filter: "blur(16px)" }}
            whileInView={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.1, delay: 0.25 * i, ease: [0.16, 1, 0.3, 1] }}
            className={`block ${l.accent ? "italic text-gold" : ""}`}
          >
            {l.text}
          </motion.span>
        ))}
      </h2>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 1.1 }}
        className="mx-auto mt-10 max-w-2xl text-base leading-relaxed text-white/60 sm:text-lg"
        data-testid="urgence-sub"
      >
        Ne vous inquiétez pas. <strong className="text-white">Urgence FK Événement</strong> — service proche de
        chez vous, disponible <strong className="text-gold">24h/24</strong>, sur place en{" "}
        <strong className="text-gold">moins d'une heure</strong>.
      </motion.p>
      <motion.a
        href={waLink(URGENT_MESSAGE)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="urgence-cta"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 1.4 }}
        className="group mt-12 inline-flex animate-pulse items-center gap-3 rounded-full bg-gold px-10 py-5 text-sm font-bold uppercase tracking-[0.2em] text-[#0a0a0a] transition-transform duration-300 hover:scale-105"
      >
        <PhoneCall className="h-5 w-5 transition-transform duration-300 group-hover:rotate-12" />
        Appel d'urgence — {WHATSAPP_DISPLAY}
      </motion.a>
    </div>
  </section>
);
